// extracted by mini-css-extract-plugin
module.exports = {"mobileNavbar":"MobileNavbar_mobileNavbar__a4BlO","link":"MobileNavbar_link__10xpa","active":"MobileNavbar_active__3Ge1M"};